import { render, staticRenderFns } from "./Uml.vue?vue&type=template&id=af245758&scoped=true&"
import script from "./Uml.vue?vue&type=script&lang=js&"
export * from "./Uml.vue?vue&type=script&lang=js&"
import style0 from "./Uml.vue?vue&type=style&index=0&id=af245758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af245758",
  null
  
)

export default component.exports